import React, { useState, useEffect } from "react";

const PARTNER_SIGNUP_URL = "https://afflat3e3.com/trk/lnk/B8B5A0FB-A60E-489E-BF05-5C5135CFB5D7/?o=16346&c=918277&a=710572&k=9B09CB199FB0D25B61692C2AA9F5014F&l=17465&s2=2";

const fadeInStyles = `
  @keyframes slide-in {
    from {
      opacity: 0;
      transform: translateX(-20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  .animate-slide-in {
    animation: slide-in 0.4s ease-out;
  }
`;

export default function SurveyLanderV2() {
  const [step, setStep] = useState(1);
  const [answers, setAnswers] = useState({
    earn: "",
    payout: "PayPal",
    time: "",
  });
  const [validationError, setValidationError] = useState("");

  useEffect(() => {
    const styleElement = document.createElement("style");
    styleElement.textContent = fadeInStyles;
    document.head.appendChild(styleElement);
    return () => document.head.removeChild(styleElement);
  }, []);

  const update = (field) => (e) => {
    setAnswers((s) => ({ ...s, [field]: e.target.value }));
    setValidationError("");
  };

  const next = () => {
    if (step === 1 && !answers.earn) {
      setValidationError("Please select how much you'd like to earn");
      return;
    }
    if (step === 2 && !answers.payout) {
      setValidationError("Please select your preferred payout method");
      return;
    }
    if (step === 3 && !answers.time) {
      setValidationError("Please select how much time you can spare");
      return;
    }

    setValidationError("");
    if (step < 4) setStep(step + 1);
  };

  const progress = Math.min(step * 25, 100);

  const gclid = typeof window !== "undefined"
    ? new URLSearchParams(window.location.search).get("gclid") || ""
    : "";

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-white text-gray-900">
      {/* Progress bar with gradient */}
      <div className="w-full bg-gray-100 h-3 sticky top-0 z-20">
        <div
          className="h-full bg-gradient-to-r from-emerald-400 to-emerald-600 transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>

      <main className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto">
          {step === 1 && (
            <StepCardV2 title="Let's find your perfect earning match!">
              <p className="text-lg text-center mb-6 text-gray-700">
                How much extra cash would you like to earn per month?
              </p>
              <div className="grid grid-cols-2 gap-4">
                <RadioCard
                  name="earn"
                  value="$20–$50"
                  checked={answers.earn === "$20–$50"}
                  onChange={update("earn")}
                >
                  $20–$50
                </RadioCard>
                <RadioCard
                  name="earn"
                  value="$50–$100"
                  checked={answers.earn === "$50–$100"}
                  onChange={update("earn")}
                >
                  $50–$100
                </RadioCard>
                <RadioCard
                  name="earn"
                  value="$100–$200"
                  checked={answers.earn === "$100–$200"}
                  onChange={update("earn")}
                >
                  $100–$200
                </RadioCard>
                <RadioCard
                  name="earn"
                  value="$200+"
                  checked={answers.earn === "$200+"}
                  onChange={update("earn")}
                >
                  $200+
                </RadioCard>
              </div>
              {validationError && (
                <p className="text-red-500 text-sm mt-4 text-center">{validationError}</p>
              )}
              <PrimaryButtonV2 onClick={next}>Continue →</PrimaryButtonV2>
            </StepCardV2>
          )}

          {step === 2 && (
            <StepCardV2 title="Choose your preferred payout method">
              <p className="text-lg text-center mb-6 text-gray-700">
                How would you like to receive your earnings?
              </p>
              <div className="grid grid-cols-1 gap-4">
                <RadioCard
                  name="payout"
                  value="PayPal"
                  checked={answers.payout === "PayPal"}
                  onChange={update("payout")}
                >
                  PayPal
                </RadioCard>
                <RadioCard
                  name="payout"
                  value="Amazon Gift Card"
                  checked={answers.payout === "Amazon Gift Card"}
                  onChange={update("payout")}
                >
                  Amazon Gift Card
                </RadioCard>
                <RadioCard
                  name="payout"
                  value="E‑Gift Card"
                  checked={answers.payout === "E‑Gift Card"}
                  onChange={update("payout")}
                >
                  E‑Gift Card
                </RadioCard>
              </div>
              {validationError && (
                <p className="text-red-500 text-sm mt-4 text-center">{validationError}</p>
              )}
              <PrimaryButtonV2 onClick={next}>Continue →</PrimaryButtonV2>
            </StepCardV2>
          )}

          {step === 3 && (
            <StepCardV2 title="Almost there!">
              <p className="text-lg text-center mb-6 text-gray-700">
                How much time can you spare each day?
              </p>
              <div className="grid grid-cols-1 gap-4">
                <RadioCard
                  name="time"
                  value="<5 min"
                  checked={answers.time === "<5 min"}
                  onChange={update("time")}
                >
                  <div className="flex items-center gap-3">
                    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                    </svg>
                    <span>Less than 5 minutes</span>
                  </div>
                </RadioCard>
                <RadioCard
                  name="time"
                  value="5–15 min"
                  checked={answers.time === "5–15 min"}
                  onChange={update("time")}
                >
                  <div className="flex items-center gap-3">
                    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                    </svg>
                    <span>5 to 15 minutes</span>
                  </div>
                </RadioCard>
                <RadioCard
                  name="time"
                  value="15–30 min"
                  checked={answers.time === "15–30 min"}
                  onChange={update("time")}
                >
                  <div className="flex items-center gap-3">
                    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                    </svg>
                    <span>15 to 30 minutes</span>
                  </div>
                </RadioCard>
              </div>
              {validationError && (
                <p className="text-red-500 text-sm mt-4 text-center">{validationError}</p>
              )}
              <PrimaryButtonV2 onClick={next}>Show my match</PrimaryButtonV2>
            </StepCardV2>
          )}

          {step === 4 && (
            <ResultCardV2 
              answers={answers} 
              href={`${PARTNER_SIGNUP_URL}${gclid ? `&gclid=${gclid}` : ""}`} 
            />
          )}
        </div>
      </main>
    </div>
  );
}

// New styled components for V2
const StepCardV2 = ({ title, children }) => (
  <div className="bg-white rounded-2xl shadow-xl p-8 animate-slide-in">
    <h2 className="text-2xl font-bold text-center mb-6 text-gray-800">{title}</h2>
    {children}
  </div>
);

const RadioCard = ({ children, checked, ...props }) => (
  <label className={`
    relative flex items-center justify-center p-4 rounded-xl border-2 cursor-pointer
    transition-all duration-200
    ${checked 
      ? 'border-emerald-500 bg-emerald-50 text-emerald-700' 
      : 'border-gray-200 hover:border-emerald-200'
    }
  `}>
    <input
      type="radio"
      className="sr-only"
      checked={checked}
      {...props}
    />
    <span className="font-medium">{children}</span>
  </label>
);

const PrimaryButtonV2 = ({ children, ...props }) => (
  <button
    {...props}
    className="w-full mt-6 py-4 bg-gradient-to-r from-emerald-500 to-emerald-600 
               text-white rounded-xl font-semibold shadow-lg 
               hover:from-emerald-600 hover:to-emerald-700 
               transition-all duration-200 transform hover:scale-[1.02]"
  >
    {children}
  </button>
);

const ResultCardV2 = ({ answers, href }) => (
  <div className="bg-white rounded-2xl shadow-xl p-8 animate-slide-in">
    <h2 className="text-3xl font-bold text-center mb-6 text-gray-800">
      Perfect! You can earn {answers.earn || "$50"} monthly
    </h2>
    
    <div className="flex items-center justify-center gap-2 mb-6">
      <div className="flex">
        {[...Array(5)].map((_, i) => (
          <svg key={i} className="w-6 h-6 fill-emerald-500" viewBox="0 0 20 20">
            <polygon points="10,1 12.472,7.128 19,7.236 13.5,11.764 15.944,18 10,14.27 4.056,18 6.5,11.764 1,7.236 7.528,7.128" />
          </svg>
        ))}
      </div>
      <span className="text-sm text-gray-600">4.5/5 rating • 30k+ reviews</span>
    </div>

    <div className="space-y-4 mb-8">
      <div className="flex items-center gap-3 text-gray-700">
        <svg className="w-6 h-6 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
        </svg>
        <span>Instant 500‑point signup bonus</span>
      </div>
      <div className="flex items-center gap-3 text-gray-700">
        <svg className="w-6 h-6 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
        </svg>
        <span>Cash out starting at $5 via {answers.payout}</span>
      </div>
      <div className="flex items-center gap-3 text-gray-700">
        <svg className="w-6 h-6 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
        </svg>
        <span>Short surveys matched to your profile</span>
      </div>
    </div>

    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="block w-full py-4 bg-gradient-to-r from-emerald-500 to-emerald-600 
                 text-white text-center rounded-xl font-semibold shadow-lg 
                 hover:from-emerald-600 hover:to-emerald-700 
                 transition-all duration-200 transform hover:scale-[1.02]"
    >
      Start Earning Now
    </a>

    <p className="text-xs text-gray-500 text-center mt-6">
      This site is independent and not endorsed by the survey platform. 
      You will complete your registration on their website.
    </p>
  </div>
); 